import { StoreItemImage } from '@givebacks/api/store';
import { useFormListValidation } from 'core';
import { Modal, Stack } from 'ui';

import { BannerImageForm } from '../../../molecules/forms/EditPeerPage/BannerImageForm/BannerImageForm';
import { SetupPeerModalFormsType } from './SetupPeerPage.types';
import { SetupPeerPageModalFooter } from './SetupPeerPageModalFooter';
import { useSetupPeerPageModalProvider } from './SetupPeerPageModalProvider';
import { SetupPeerPageStepper } from './SetupPeerPageStepper';

const SetupBannerImageModalFooter = ({ peerImage }: { peerImage?: StoreItemImage }) => {
  const { useGetForm } = useFormListValidation<SetupPeerModalFormsType>();

  const form = useGetForm('bannerImage');

  return (peerImage || form?.values?.file) && <SetupPeerPageModalFooter isShowSkip={false} />;
};

const SetupBannerImageModal = () => {
  const { opened, closeAllModals, openNextStep, meta } = useSetupPeerPageModalProvider({
    id: 'bannerImage',
  });

  return (
    <Modal opened={opened} onClose={closeAllModals} title="Banner Image">
      <Stack gap="lg">
        <SetupPeerPageStepper activeStep={0} />
        <BannerImageForm initialValue={meta.peer.image} onSkip={openNextStep} />
      </Stack>

      <SetupBannerImageModalFooter peerImage={meta.peer.image} />
    </Modal>
  );
};

export { SetupBannerImageModal };
